<div class="tal-monaco-editor" [class.blur]="isBlurred">
    <ngx-monaco-editor class="tal-monaco-editor-ngx"
        #monacoEditor 
        [lang]="language" 
        [options]="editorOptions" 
        [(ngModel)]="value">
    </ngx-monaco-editor>
</div>
    